<template>
    <div>
        <div class="head">
            <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/reservePlan'}">预案管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.id ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content" style="background: #fff;">
            <el-form :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="100px"
                     class="demo-ruleForm"
                     style="width:60%;margin:0 auto">
                <el-form-item label="编号" prop="name">
                    <el-input size="small" :disabled="isShow" v-model="ruleForm.planNum" style="width:500px"/>
                </el-form-item>
                <el-form-item label="名称" prop="jobs">
                    <el-input size="small" :disabled="isShow" v-model="ruleForm.planName" style="width:500px"/>
                </el-form-item>
                <el-form-item label="类型" prop="jobs">
                    <el-input v-model="ruleForm.planType" style="width: 500px" size="small"/>
                    <!-- <el-select size="small" :disabled="isShow" v-model="ruleForm.planType" placeholder="请添加">
                      <el-option
                        v-for="item in planType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="危险源" prop="jobs">
                    <!-- <el-select size="small" v-model="ruleForm.dangerType" placeholder="请添加" :disabled="isShow">
                      <el-option v-for="item in dangerType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select> -->
                    <el-input v-model="ruleForm.dangerType" placeholder="" style="width:500px" :disabled="isShow"/>
                </el-form-item>
                <el-form-item label="级别" prop="jobs">
                    <el-select size="small" v-model="ruleForm.planLevel" placeholder="请添加" :disabled="isShow">
                        <el-option v-for="item in planLevel"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="区域" prop="jobs">
                    <Select v-model="locationIds" multiple placeholder="请添加" :disabled="isShow" style="width: 95%">
                        <Option v-for="item in locations"
                                :key="item.id"
                                :label="item.cellName"
                                :value="item.id"
                        />
                    </Select>
                </el-form-item>
                <el-form-item label="编写人" prop="plannerId">
                    <Select v-model="ruleForm.plannerId" placeholder="请添加" style="width:95%;margin-top: 8px"
                            :disabled="isShow">
                        <Option v-for="item in userData"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id"
                        />
                    </Select>
                </el-form-item>
                <el-form-item label="编写部门" prop="plannerDep">
                    <Select v-model="ruleForm.plannerDep" placeholder="请添加" style="width:95%;margin-top: 8px"
                            :disabled="isShow">
                        <Option v-for="item in depData"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        />
                    </Select>
                </el-form-item>
                <el-form-item label="发布实施日期" prop="jobs">
                    <el-date-picker size="small"
                                    v-model="ruleForm.implementationTime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="选择日期"
                                    :disabled="isShow"
                    />
                </el-form-item>
                <el-form-item label="文件" prop="jobs">
                    <el-upload class="upload-demo"
                               drag
                               :on-change="handleChange"
                               :file-list="fileList"
                               action="/v1/drillingPlan/uploadEditorFile"
                               :limit="1"
                               :disabled="isShow"
                               :on-exceed='handleExceed'>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="审批人"
                              prop="plannerId">
                    <Select v-model="checkUsers"
                            multiple
                            placeholder="请添加"
                            style="height: 66px;width:95%;margin-top: 8px"
                            :disabled="isShow">
                        <Option v-for="item in userData"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id"></Option>
                    </Select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small"
                               v-if="type == 0 || type == 3"
                               type="primary"
                               class="addBtn"
                               style="margin-top: 2%"
                               @click="submitForm()">确定
                    </el-button>
                    <el-button size="small"
                               v-if="type == 1"
                               type="primary"
                               style="margin-top: 2%"
                               class="addBtn"
                               @click="submitForm(0)">同意
                    </el-button>
                    <el-button size="small"
                               v-if="type == 1"
                               type="danger"
                               style="margin-top: 2%"
                               class="addBtn"
                               @click="submitForm(6)">驳回
                    </el-button>
                    <el-button size="small"
                               v-if="type == 2"
                               type="primary"
                               style="margin-top: 2%"
                               class="addBtn"
                               @click="submitForm(4)">确认修订
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                type: 0,
                isShow: false,
                ruleForm: {},
                rules: {},
                checkUsers: [],
                locationIds: [],
                options: [],
                getObj: {},
                planType: [
                    {id: 0, name: '类型一'},
                    {id: 1, name: '类型二'},
                    {id: 2, name: '类型三'},
                    {id: 3, name: '类型四'},
                    {id: 4, name: '类型五'},
                    {id: 5, name: '类型六'}
                ],
                dangerType: [
                    {id: 0, name: '甲类车间（非重大危险源）'},
                    {id: 1, name: '埋地储罐区（非重大危险源）'},
                    {id: 2, name: '甲类仓库（非重大危险源）'}
                ],
                planLevel: [
                    {id: 0, name: '公司级'},
                    {id: 1, name: '分厂级'},
                    {id: 2, name: '车间级'}
                ],
                locations: [],
                fileList: [],
                depData: [],
                userData: []
            }
        },
        mounted: function () {
            this.getLocations()
            this.getAllEmpInfo()
            this.getUserData()
        },
        methods: {
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3)
            },
            //获取部门 信息
            getAllEmpInfo() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData('urls').getAllEmplotee)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.depData = res.body.data
                    })
            },
            getUserData() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData('urls').getAllUser)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.userData = res.body.data
                    })
            },
            getLocations() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(
                        '/dangerinfo/list_all?limit=' + 500 + '&curPage=' + 1
                    )
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.locations = res.body.data
                    })
            },
            getInfoData(id) {
                this.componentsMoudel.httpRequest
                    .getRequestHander('/planManagement/info/' + id)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.ruleForm = res.body.data
                        let files = JSON.parse(this.ruleForm.planFile)
                        this.locationIds = this.ruleForm.locationIds
                        this.checkUsers = this.ruleForm.checkUserIdList
                        for (var i = 0; i < files.length; i++) {
                            let myFile = {}
                            var file = files[i]
                            myFile.name = file.fileName
                            myFile.response = {}
                            myFile.response.data = file.url
                            this.fileList.push(myFile)
                        }
                    })
            },
            submitForm(status) {
                var fileArray = []
                let url = ''
                for (let item in this.fileList) {
                    var fileInfo = {}
                    fileInfo.fileName = this.fileList[item].name
                    fileInfo.url = this.fileList[item].response.data
                    fileArray.push(fileInfo)
                }
                if (this.type == 0) {
                    //添加
                    url = '/planManagement/save'
                } else if (this.type == 3) {
                    // 修改
                    url = '/planManagement/update'
                } else {
                    // 审核
                    url = '/planManagement/update'
                    this.ruleForm.status = status
                }
                this.ruleForm.locationId = this.locationIds.join(',')
                this.ruleForm.platformFileDto = fileArray
                this.ruleForm.checkUserIds = this.checkUsers.join(',')
                this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.ruleForm)
                    .then(res => {
                        if (res.body.status_code == 100) {
                            this.$message({
                                showClose: true,
                                message: '操作成功',
                                type: 'success'
                            })

                            this.$router.push({
                                path: '/processManager/reservePlan'
                            })
                        } else {
                            this.$message.error('操作失败')
                        }
                    })
            },
            // 限制文件上传个数
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件，本次选择了 ${
                        files.length
                    } 个文件，共选择了 ${files.length + fileList.length} 个文件`
                )
            }
        },
        created() {
            let obj = this.$route.params.key
            if (this.$route.params.key) {
                this.type = this.$route.params.id
                if (this.type == 0 || this.type == 3 || this.type == 2) {
                    this.isShow = false
                } else {
                    this.isShow = true
                }
                this.getInfoData(obj.id)
            } else {
                // 添加
                this.ruleForm = {}
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    /* .myHead {
      position: absolute;
      top: 0px;
      left: 250px;
      width: 80%;
      height: 160px;
    } */
</style>
